<template>
  <svg
    class="RefreshIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1954_18968"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1954_18968)">
      <path
        d="M12.0498 19.5C9.9498 19.5 8.1748 18.775 6.7248 17.325C5.2748 15.875 4.5498 14.1 4.5498 12C4.5498 9.9 5.2748 8.125 6.7248 6.675C8.1748 5.225 9.9498 4.5 12.0498 4.5C13.2165 4.5 14.3208 4.75833 15.3628 5.275C16.4041 5.79167 17.2665 6.525 17.9498 7.475V4.5H19.4498V10.625H13.3498V9.125H17.2998C16.7665 8.15833 16.0331 7.396 15.0998 6.838C14.1665 6.27933 13.1498 6 12.0498 6C10.3831 6 8.96647 6.58333 7.7998 7.75C6.63314 8.91667 6.0498 10.3333 6.0498 12C6.0498 13.6667 6.63314 15.0833 7.7998 16.25C8.96647 17.4167 10.3831 18 12.0498 18C13.3331 18 14.4915 17.6333 15.5248 16.9C16.5581 16.1667 17.2831 15.2 17.6998 14H19.2748C18.8248 15.6333 17.9291 16.9583 16.5878 17.975C15.2458 18.9917 13.7331 19.5 12.0498 19.5Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'RefreshIcon',
};
</script>

<style lang="scss" scoped>
.RefreshIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
